import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect,Input,OnChanges,SimpleChanges } from '@angular/core';
import { UserService } from '@services/core/user.service';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2'
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { FilterModel } from './filter.model';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-budget-over-view',
  standalone: true,
  imports: [DecimalPipe, NgSelectModule, FormsModule, CommonModule],
  providers: [ { provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './budget-over-view.component.html',
  styleUrl: './budget-over-view.component.css'
})
export class BudgetOverViewComponent implements OnChanges {
  @Input() data;
  @Input() filterItemCode!: string;
  @Input() fundCode!: string;
  @Input() departament;
  private _identityService = inject(UserService);
  public entitySelected: Entity;
  public budgetGenerateService= inject(BudgetGenerateService)
  public items;
  public selectedDepartament;
  public filter: FilterModel = new FilterModel();
  public expenses;
  public expensesItemTotal;
  public expensesTotal;
  public expenseTotalsByDept={};
  public expensesTotalsByDept;


  constructor(private route: ActivatedRoute

  ) {


    effect(() => {
      this.entitySelected = this._identityService.sharingEntity();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {
      }

    })

  }


  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] ) {
      this.items=changes['data'].currentValue; 
      if(this.entitySelected?.group=='IASD'){
        this.filterExpenses();
        this.expensesTotalsByDept=this.calculateDepartmentItemTotals(this.items);
        this.expensesTotalsByDept=this.orderByDepartament(this.expensesTotalsByDept);
      }
    }
    if (changes['filterItemCode'] ) {
      this.filter.departamentItemCode=changes['filterItemCode'].currentValue;
    }
    if (changes['departament'] ) {
      this.selectedDepartament=changes['departament'].currentValue;  
    }
  }



  getTotalRevenue(revenueTotals: { fundCode: number; totalValue: number }[]): number {
    return revenueTotals?.reduce((acc, curr) => acc + (curr.totalValue || 0), 0) || 0;
  }

  getTotalExpense(expenseTotals: { fundCode: number; totalValue: number }[]): number {
    return expenseTotals?.reduce((acc, curr) => acc + (curr.totalValue || 0), 0) || 0;
  }
  
findTotalByDepartament(departamentFundCode){ 
  return this.expensesTotalsByDept?.find(i=>i.departamentFundCode==departamentFundCode)
}


orderByDepartament(expenses){
  return expenses.sort((a,b)=>a.departamentFundCode-b.departamentFundCode);
}



/**total por item */
calculateDepartmentItemTotals(items) {
  const expenses=items?.expensesDepartamentFunds;
  let result=[];
  if (Array.isArray(expenses)) {
    
  const grouped = {};

  for (const expense of expenses) {
    const key = `${expense?.departamentFundCode}`;
    
    if (!grouped[key]) {
      grouped[key] = {
        ...expense,
        totalValue: 0 
      };
    }

    grouped[key].totalValue += Number(expense.totalValue ??0);
  }

  result=Object.values(grouped);
  }
  return result;
}

findTitheTotal(){
  return this.items?.revenuesDepartaments?.find(i=>i.code=='0001')?.totalValue;
}



  filterExpenses(){
    this.expenseTotalsByDept = {};
    this.expenses=this.items?.expensesDepartamentFunds?.filter(i=>i.code==this.filterItemCode).sort((a,b)=> b.departamentFundCode.localeCompare(a.departamentFundCode));
    this.items?.expensesDepartamentFunds?.forEach(e => {
      const dept = e.departamentFundCode.toString();
      const total = e.totalValue ?? 0;
      this.expenseTotalsByDept[dept] = (this.expenseTotalsByDept[dept] ?? 0) + total;
    });
    this.expensesItemTotal = this.expenses?.reduce((sum, i) => sum + (i.totalValue ?? 0), 0);
  }


  calculateFactor(){
    if(!this.items){
      return 0;
    }
    const factor=0;
    return factor;
    
    
  }


  findItemRevenue(itemCode){
    
    return this.items?.revenues?.find(i=>i.code==itemCode)
  }



findItemExpense(code){
  return this.items?.expenses?.find(i=>i.code==code)
}

findItemExpenseDepartament(code){ 
  return this.items?.expensesDepartaments?.find(i=>i.code==code)
}


findItemExpenseDepartamentFund(code){ 
  return this.items?.expensesDepartamentFunds?.find(i=>i.code==code)
}


findItemRevenueDepartament(code){ 
  return this.items?.revenuesDepartaments?.find(i=>i.code==code)
}


findItemRevenueParent(code){   
  return this.items?.revenuesParents?.find(i=>i.code==code)
}

findItemExpenseParent(code){
  return this.items?.expensesParents?.find(i=>i.code==code)
}


capitalize(value){
value=value??'';
  return value
    .toLowerCase()
    .split(' ')
    .map(word => 
      word
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join('-')
    )
    .join(' ');
}




}